// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
export enum ProjectTeamMemberRole {
Sponsor,
ProjectManager,
TechnicalLead,
Researcher,
SoftwareEngineer,
Administration,
Financial,
Other,
}
